import {
  TOGGLE_RISK_REQUEST,
  TOGGLE_RISK_SUCCESS,
  TOGGLE_RISK_FAILURE,
  UPDATE_RISK_REQUEST,
  UPDATE_RISK_SUCCESS,
  UPDATE_RISK_FAILURE,
  CREATE_RISK_REQUEST,
  CREATE_RISK_SUCCESS,
  CREATE_RISK_FAILURE,
  DELETE_RISK_REQUEST,
  DELETE_RISK_SUCCESS,
  DELETE_RISK_FAILURE,
  UPDATE_RISK_BY_LEVEL_REQUEST,
  UPDATE_RISK_BY_LEVEL_SUCCESS,
  UPDATE_RISK_BY_LEVEL_FAILURE,
  DELETE_RISK_BY_LEVEL_REQUEST,
  DELETE_RISK_BY_LEVEL_SUCCESS,
  DELETE_RISK_BY_LEVEL_FAILURE,
  CLEAR_RISK
 } from '../constants'
import Api from '../services/api.js'

export function toggleRiskRequest(){
  return {
    type: TOGGLE_RISK_REQUEST
  }
}

export function toggleRiskSuccess(result, id, hidden){
  return {
    type: TOGGLE_RISK_SUCCESS,
    result: result,
    id: id,
    hidden: hidden
  }
}

export function toggleRiskFailure(exception){
  return {
    type: TOGGLE_RISK_FAILURE,
    exception: exception
  }
}

export function updateRiskRequest(){
  return {
    type: UPDATE_RISK_REQUEST,
  }
}

export function updateRiskSuccess(body, cellValue, row){
  return {
    type: UPDATE_RISK_SUCCESS,
    body: body,
    cellValue: cellValue,
    row: row
  }
}

export function updateRiskFailure(exception){
  return {
    type: UPDATE_RISK_FAILURE,
    exception: exception
  }
}

export function createRiskRequest(){
  return {
    type: CREATE_RISK_REQUEST,
  }
}

export function createRiskSuccess(body){
  return {
    type: CREATE_RISK_SUCCESS,
    body: body,
  }
}

export function createRiskFailure(exception){
  return {
    type: CREATE_RISK_FAILURE,
    exception: exception
  }
}

export function clearRisk(){
  return {
    type: CLEAR_RISK
  }
}

export function deleteRiskRequest(){
  return {
    type: DELETE_RISK_REQUEST,
  }
}

export function deleteRiskSuccess(body){
  return {
    type: DELETE_RISK_SUCCESS,
    body: body,
  }
}

export function deleteRiskFailure(exception){
  return {
    type: DELETE_RISK_FAILURE,
    exception: exception
  }
}

export function updateRiskByLevelRequest(){
  return {
    type: UPDATE_RISK_BY_LEVEL_REQUEST,
  }
}

export function updateRiskByLevelSuccess(body){
  return {
    type: UPDATE_RISK_BY_LEVEL_SUCCESS,
    body: body
  }
}

export function updateRiskByLevelFailure(exception){
  return {
    type: UPDATE_RISK_BY_LEVEL_FAILURE,
    exception: exception
  }
}

export function deleteRiskByLevelRequest(){
  return {
    type: DELETE_RISK_BY_LEVEL_REQUEST,
  }
}

export function deleteRiskByLevelSuccess(body){
  return {
    type: DELETE_RISK_BY_LEVEL_SUCCESS,
    body: body
  }
}

export function deleteRiskByLevelFailure(exception){
  return {
    type: DELETE_RISK_BY_LEVEL_FAILURE,
    exception: exception
  }
}

export function toggleRisk(plan_id, risk_id, hidden) {
  let params = {
    hidden: hidden.toString(),
    plan_id: plan_id
  }
  return dispatch => {
    dispatch(toggleRiskRequest())
    const api = new Api();
    return api.toggleRisk("/__api/v1/risk/" + risk_id + "/toggle_status", params)
    .then(response => {
      dispatch(toggleRiskSuccess(response.data.result, risk_id, hidden))
    })
    .catch(error => dispatch(toggleRiskFailure(error)));
  }
}

export function toggleAllRisks(plan_id, hidden) {
  let params = {
    hidden: hidden.toString(),
    plan_id: plan_id
  }
  return dispatch => {
    dispatch(toggleRiskRequest())
    const api = new Api();
    return api.toggleRisk("/__api/v1/toggle_statuses", params)
    .then(response => {
      dispatch(toggleRiskSuccess(response.data.result, 'all', hidden))
    })
    .catch(error => dispatch(toggleRiskFailure(error)));
  }
}

export function updateRisk(plan_id, risk, cellValue, row) {
  let params = {
    metadata: risk.metadata,
    plan_id: plan_id
  }
  return dispatch => {
    dispatch(updateRiskRequest())
    const api = new Api();
    return api.put("/__api/v1/risk/"+ risk.id, params)
    .then(response => {
      dispatch(updateRiskSuccess(response.data, cellValue, row))
    })
    .catch(err => dispatch(updateRiskFailure(err)));
  }
}

export function createRisk(plan_id, risk) {
  let params = {
    risk: risk
  }

  return dispatch => {
    dispatch(createRiskRequest())
    const api = new Api();
    return api.post("/__api/v1/plan/"+ plan_id + "/create_risk", params)
    .then(response => {
      dispatch(createRiskSuccess(response.data))
    })
    .catch(err => dispatch(createRiskFailure(err)));
  }
}

export function deleteRisk(plan_id, risk) {
  let params = {
    plan_id: plan_id
  }
  return dispatch => {
    dispatch(deleteRiskRequest())
    const api = new Api();
    return api.delete("/__api/v1/risk/"+ risk.id, { params:params })
    .then(response => {
      dispatch(deleteRiskSuccess(response.data))
    })
    .catch(err => dispatch(deleteRiskFailure(err)));
  }
}

export function updateRiskByLevel(plan_id, new_value, search_term, column_name, include_hidden_risks, work_phase, activity) {
  let params = {
    search_term: search_term,
    column_name: column_name,
    include_hidden_risks: include_hidden_risks.toString(),
    new_value: new_value,
    work_phase: work_phase,
    activity: activity,
    plan_id: plan_id
  }
  return dispatch => {
    dispatch(updateRiskByLevelRequest())
    const api = new Api();
    return api.put("/__api/v1/update_by_level", params)
    .then(response => {
      dispatch(updateRiskByLevelSuccess(response.data))
    })
    .catch(err => dispatch(updateRiskByLevelFailure(err)));
  }
}

export function deleteRiskByLevel(plan_id, search_term, column_name, include_hidden_risks, work_phase, activity) {
  let params = {
    search_term: search_term,
    column_name: column_name,
    include_hidden_risks: include_hidden_risks.toString(),
    work_phase: work_phase,
    activity: activity,
    plan_id: plan_id
  }
  return dispatch => {
    dispatch(deleteRiskByLevelRequest())
    const api = new Api();
    return api.delete("/__api/v1/destroy_by_level", {params:params})
    .then(response => {
      dispatch(deleteRiskByLevelSuccess(response.data))
    })
    .catch(err => dispatch(deleteRiskByLevelFailure(err)));
  }
}

export function switchRisksVisibilityByLevel(params) {
  return dispatch => {
    dispatch(updateRiskByLevelRequest())
    const api = new Api();
    return api.put("/__api/v1/risks/switch_visibility", params)
    .then(response => {
      dispatch(updateRiskByLevelSuccess(response.data))
    })
    .catch(err => dispatch(updateRiskByLevelFailure(err)));
  }
}



// WEBPACK FOOTER //
// ./src/actions/risk.js